import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftsStatuses';

import { DraftStatus } from '../../model/draft';
import { Channel } from '../../model/skill';

const t = i18n(keyset);

const DEFAULT_STRINGS: Record<DraftStatus, ''> = {
    [DraftStatus.InDevelopment]: '',
    [DraftStatus.ReviewRequested]: '',
    [DraftStatus.ReviewApproved]: '',
    [DraftStatus.DeployRequested]: '',
    [DraftStatus.ReviewCancelled]: '',
    [DraftStatus.ReviewRejected]: '',
    [DraftStatus.DeployRejected]: '',
    [DraftStatus.TestRequired]: '',
    [DraftStatus.MeetingApproval]: '',
    [DraftStatus.WaitingForTesting]: '',
    [DraftStatus.AppScanRequested]: '',
    [DraftStatus.AppScanRequestedAfterModeration]: '',
    [DraftStatus.DevicesTesting]: '',
    [DraftStatus.DevicesTestingCompleted]: '',
};

export const smartHomeStatuses: Record<DraftStatus, '' | keyof (typeof keyset)['en']> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.InDevelopment]: 'sh-in-dev',
    [DraftStatus.ReviewRequested]: 'sh-review-requested',
    [DraftStatus.MeetingApproval]: 'sh-meeting',
    [DraftStatus.WaitingForTesting]: 'sh-waiting',
    [DraftStatus.DevicesTesting]: 'sh-testing',
    [DraftStatus.DevicesTestingCompleted]: 'sh-analysis',
    [DraftStatus.ReviewApproved]: 'sh-approved',
    [DraftStatus.DeployRequested]: 'deploy-requested',
};

export const getDraftStatusHint = () => ({
    ...DEFAULT_STRINGS,
    [DraftStatus.InDevelopment]: t('hint-in-dev'),
});

const getCommonCompletedModerationStateTexts = () => ({
    ...DEFAULT_STRINGS,
    [DraftStatus.ReviewRequested]: t('ready'),
    [DraftStatus.ReviewApproved]: t('ready'),
    [DraftStatus.DeployRequested]: t('ready'),
});

const getSmartHomeCompletedModerationStateTexts = () => ({
    ...DEFAULT_STRINGS,
    [DraftStatus.ReviewRequested]: t('ready'),
    [DraftStatus.MeetingApproval]: t('ready'),
    [DraftStatus.WaitingForTesting]: t('ready'),
    [DraftStatus.DevicesTesting]: t('ready'),
    [DraftStatus.DevicesTestingCompleted]: t('ready'),
    [DraftStatus.ReviewApproved]: t('ready'),
    [DraftStatus.DeployRequested]: t('ready'),
});

export const smartHomeModerationLabels: Record<DraftStatus, '' | keyof (typeof keyset)['en']> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.ReviewRequested]: 'ready',
    [DraftStatus.MeetingApproval]: 'ready',
    [DraftStatus.WaitingForTesting]: 'ready',
    [DraftStatus.DevicesTesting]: 'ready',
    [DraftStatus.DevicesTestingCompleted]: 'ready',
    [DraftStatus.ReviewApproved]: 'ready',
    [DraftStatus.DeployRequested]: 'ready',
};

export const getCompletedModerationStateTexts = () => ({
    [Channel.AliceSkill]: getCommonCompletedModerationStateTexts(),
    [Channel.Thereminvox]: getCommonCompletedModerationStateTexts(),
    [Channel.SmartHome]: getSmartHomeCompletedModerationStateTexts(),
    [Channel.TvApp]: getCommonCompletedModerationStateTexts(),
    [Channel.SmartScreenApp]: getCommonCompletedModerationStateTexts(),
    [Channel.AutoApp]: getCommonCompletedModerationStateTexts(),
});
